const i = {
  "mobile-navigation-block": "mobile-navigation-block",
  "mobile-navigation-block__chevron": "mobile-navigation-block__chevron",
  "mobile-navigation-block--open": "mobile-navigation-block--open",
  "mobile-navigation-block__button": "mobile-navigation-block__button",
  "mobile-navigation-block__submenu-list": "mobile-navigation-block__submenu-list",
  "mobile-navigation-block--active": "mobile-navigation-block--active",
  "mobile-navigation-block__link": "mobile-navigation-block__link",
  "mobile-navigation-block__submenu-list--depth-1": "mobile-navigation-block__submenu-list--depth-1",
  "mobile-navigation-block__submenu-list--depth-2": "mobile-navigation-block__submenu-list--depth-2",
  "mobile-navigation-block__submenu-list--depth-3": "mobile-navigation-block__submenu-list--depth-3",
  "mobile-navigation-block__submenu-item": "mobile-navigation-block__submenu-item",
  "mobile-navigation-block__submenu-item--active": "mobile-navigation-block__submenu-item--active",
  "mobile-navigation-block__submenu-item-title": "mobile-navigation-block__submenu-item-title",
  "mobile-navigation-block__submenu-item-title--active": "mobile-navigation-block__submenu-item-title--active",
  "mobile-navigation-block__submenu-item-arrow": "mobile-navigation-block__submenu-item-arrow",
  "mobile-navigation-block__submenu-item-link": "mobile-navigation-block__submenu-item-link"
};
export {
  i as default
};
